import {
  createCodeUsageGeneratorRegistry,
  type CodeUsageGenerator,
} from "fumadocs-openapi/requests/generators";
import { registerDefault } from "fumadocs-openapi/requests/generators/all";

const FALLBACK_CODE_SAMPLE_ORIGIN = "https://api.pdfparse.net";
const configuredOrigin =
  process.env.NEXT_PUBLIC_DOCS_CODE_SAMPLE_ORIGIN ??
  FALLBACK_CODE_SAMPLE_ORIGIN;
const codeSampleOrigin = configuredOrigin.replace(/\/+$/, "");

function normalizeCodeSampleUrl(input: string): string {
  try {
    const parsed = new URL(input);
    return `${codeSampleOrigin}${parsed.pathname}${parsed.search}`;
  } catch {
    return input;
  }
}

export const codeUsages = createCodeUsageGeneratorRegistry();
registerDefault(codeUsages);

for (const [id, generator] of Array.from(codeUsages.map().entries())) {
  const wrapped: CodeUsageGenerator = {
    ...generator,
    generate(data, context) {
      return generator.generate(
        { ...data, url: normalizeCodeSampleUrl(data.url) },
        context,
      );
    },
  };
  codeUsages.add(id, wrapped);
}
